"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImFileTranslator = void 0;
const im_translator_1 = require("./im-translator");
class ImFileTranslator extends im_translator_1.ImTranslator {
    constructor(resourceLoader, locale) {
        super(locale, !!resourceLoader.showLogs);
        this.resourceLoader = resourceLoader;
    }
    fetchResource(resource) {
        const url = `${this.resourceLoader.url}/${resource}.json`;
        const fetchOptions = { method: 'GET' };
        if (!!this.resourceLoader.isEditingEnabled) {
            fetchOptions.cache = "no-store";
        }
        return fetch(url, fetchOptions);
    }
    loadTranslations(resource) {
        let loader = this.loaders[resource];
        if (!loader) {
            loader = this.loaders[resource] =
                new Promise((resolve, reject) => {
                    this.fetchResource(resource)
                        .then((response) => {
                        if (response.ok) {
                            return response.json();
                        }
                        this.translations[resource] = {};
                        console.error(`Failed to load '${resource}' resource. Response status - ${response.status}`);
                        reject();
                    })
                        .then((data) => {
                        this.translations[resource] = this.flattenJSON(data);
                        resolve();
                    })
                        .catch(err => {
                        this.translations[resource] = {};
                        console.error(`Failed to load '${resource}' resource. Check if service is available.`);
                        reject();
                    });
                });
        }
        return loader;
    }
    translate(key, interpolateParams, returnKeyIfNotFound = true) {
        return this._translate(this.locale, key, interpolateParams, returnKeyIfNotFound);
    }
    translateInstant(key, interpolateParams, returnKeyIfNotFound = true) {
        return this._translateInstant(this.locale, key, interpolateParams, returnKeyIfNotFound);
    }
    flattenJSON(obj = {}, res = {}, extraKey = '') {
        for (const key in obj) {
            if (typeof obj[key] !== 'object') {
                res[extraKey + key] = obj[key];
            }
            else {
                this.flattenJSON(obj[key], res, `${extraKey}${key}.`);
            }
        }
        return res;
    }
}
exports.ImFileTranslator = ImFileTranslator;
